import { render, staticRenderFns } from "./VIPclass.vue?vue&type=template&id=f1e5e93c&scoped=true"
import script from "./VIPclass.vue?vue&type=script&lang=js"
export * from "./VIPclass.vue?vue&type=script&lang=js"
import style0 from "./VIPclass.vue?vue&type=style&index=0&id=f1e5e93c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e5e93c",
  null
  
)

export default component.exports